import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Reveal, Label } from "./Reveal";
import { Stars } from "@/pages/admin/ReviewsPanel";

export const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    const base = process.env.REACT_APP_BACKEND_URL;
    if (!base) return undefined;
    axios.get(`${base}/api/reviews`)
      .then((r) => setReviews(Array.isArray(r.data?.reviews) ? r.data.reviews : []))
      .catch(() => setReviews([]));
    return undefined;
  }, []);

  if (reviews.length === 0) return null;
  const [lead, ...rest] = reviews;
  return (
    <section className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36" data-testid="reviews-section">
      <Reveal>
        <Label>From our clients</Label>
        <h2 className="font-serif-d mt-5 text-5xl leading-[0.95] text-white sm:text-6xl">In their <span className="italic text-[var(--teal)]">words.</span></h2>
      </Reveal>
      <div className="mt-14 grid gap-4 lg:grid-cols-12">
        <Reveal className={rest.length ? "lg:col-span-7" : "lg:col-span-12"}>
          <figure className="flex h-full flex-col justify-between rounded-3xl bg-[var(--paper)] p-8 text-[var(--navy)] sm:p-12" data-testid={`review-card-${lead.id}`}>
            <Stars n={lead.rating} className="h-5 w-5" />
            <blockquote className="font-serif-d mt-8 text-3xl leading-tight sm:text-4xl">“{lead.text}”</blockquote>
            <figcaption className="mt-8 text-sm font-semibold">{lead.display_name}{lead.role ? <span className="font-normal text-slate-600">, {lead.role}</span> : null}</figcaption>
          </figure>
        </Reveal>
        {rest.length > 0 && (
          <div className="grid gap-4 lg:col-span-5">
            {rest.slice(0, 5).map((r, i) => (
              <Reveal key={r.id} delay={i * 0.08}>
                <motion.figure whileHover={{ y: -4 }} className="rounded-3xl border border-white/10 bg-[var(--navy-2)] p-7" data-testid={`review-card-${r.id}`}>
                  <Stars n={r.rating} />
                  <blockquote className="mt-4 text-base leading-relaxed text-slate-200">“{r.text}”</blockquote>
                  <figcaption className="mt-4 text-sm text-slate-400">{r.display_name}{r.role ? `, ${r.role}` : ""}</figcaption>
                </motion.figure>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
